require('./brokerETFsSellSuccess.scss');
require('./brokerETFsSellSuccess.override.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { formatText } = require('core/i18n').i18n;

// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const StocksBuySellSummary = require('components/broker/commons/stocksBuySellSummary/stocksBuySellSummary');

// @helpers
const {
    FIRST_STEP,
    SECOND_STEP,
    BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER,
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL,
    TYPE_ETFS
} = require('constants/index');

const BrokerETFsSellSuccess = props => {
    const { productFile, immBrokerETFsSell, immStocksContracts } = props;
    const mockedOrderNumber = immBrokerETFsSell.get('orderNumber');
    const successMessage = formatText('broker-etfsSellSuccessStepMessage');
    const successSubMessage = formatText('broker-etfsSellSuccessStepSubMessage', [
        mockedOrderNumber
    ]); //@hardcoded and mocked 'til we receive this from the reducer
    const mainButtonLabel = formatText('broker-etfsSellSuccessStepBackToWalletButtonLabel');
    const secondaryButtonLabel = formatText(
        'broker-etfsSellSuccessStepReviewOrdersButtonLabel'
    );
    const step1 = immBrokerETFsSell.get('steps').get(FIRST_STEP);
    const step2 = immBrokerETFsSell.get('steps').get(SECOND_STEP);
    const productCurrency = productFile.get('currency');
    const selectedContractValue = immBrokerETFsSell.getIn([
        'steps',
        FIRST_STEP,
        'stocksContractSelectedValue'
    ]);
    const stockContract = immStocksContracts.find(contract => {
        return contract.get('contactNumber') === selectedContractValue;
    });

    if (!stockContract) {
        return;
    }

    return (
        <WizardSuccess
            successMessage={successMessage}
            successSubMessage={successSubMessage}
            customClassName="etfs-sell-success"
            mainButton={{ label: mainButtonLabel, url: MYPROFILE_BROKER_URL }}
            secondaryButton={{
                label: secondaryButtonLabel,
                url: MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL
            }}
        >
            <StocksBuySellSummary
                productName={formatText('broker-etfSummaryProductName')}
                productCurrency={productCurrency}
                stockContract={stockContract}
                stockDescription={productFile.get('companyName')}
                step1={step1}
                step2={step2}
                modifier={BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER}
                productIso={productFile.get('micCode')}
                productType={TYPE_ETFS}
                titlesQuantityTitle="stocksBuySellSummaryTitlesQuantityParticipations"
            />
        </WizardSuccess>
    );
};

BrokerETFsSellSuccess.propTypes = {
    productFile: PropTypes.object.isRequired,
    immBrokerETFsSell: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired
};

module.exports = BrokerETFsSellSuccess;